import { Flex, Typography, theme } from 'antd';
import { FC } from 'react';
import { PatchCheck, PatchExclamation } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { AppCardList } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { useGetAllSearchConsoleAccountsQuery } from '@/modules/DomainsApi';

interface Props {
  currentPage: number;
  searchConsoleAccountsListItems: BaseQueryParams<typeof useGetAllSearchConsoleAccountsQuery>['data']['items'];
  searchConsoleAccountsListTotalItems: BaseQueryParams<typeof useGetAllSearchConsoleAccountsQuery>['data']['meta']['totalItems'];
  searchConsoleAccountsListItemsPerPage: BaseQueryParams<typeof useGetAllSearchConsoleAccountsQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const SearchConsoleAccountsListView: FC<Props> = ({
  currentPage,
  searchConsoleAccountsListItems,
  searchConsoleAccountsListTotalItems,
  searchConsoleAccountsListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const { token } = theme.useToken();
  const accountId = useParams()['*'];

  return (

    <AppCardList
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: searchConsoleAccountsListTotalItems,
        pageSize: searchConsoleAccountsListItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      selectedKey={ searchConsoleAccountsListItems.find(({ id }) => accountId?.includes(id))?.id ?? undefined }
      rowKey="id"
      titleKey="email"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 3
      }}
      navigateTo={ ({ id }) => ({
        to: AppRoutes.DomainsApiSearchConsoleAccountsById.replace(':searchConsoleAccountId', id),
      }) }
      list={ searchConsoleAccountsListItems }
      content={ (record) => (
        <Flex vertical gap={ 4 }>
          {
            record.isReadyToUse
              ? <Flex align="center">
                <PatchCheck color={ token.colorSuccess }/>&nbsp;Валідний
              </Flex>
              : <Flex align="center">
                <PatchExclamation color={ token.colorError }/>&nbsp;Не можна використовувати
              </Flex>
          }
          { record.refreshTokenError && (
            <Typography.Text
              type={ record.isReadyToUse ? 'warning' : 'danger' }
              ellipsis={{ tooltip: record.refreshTokenError }}
            >
              { record.refreshTokenError }
            </Typography.Text>
          ) }
        </Flex>
      ) }
    />
  );
};
